module.exports = __webpack_public_path__ + "08_long_black.a65f1a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/08_long_black.png
// module id = vu/A
// module chunks = 0